import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Select, Tag } from 'antd';
import { CollectionServer, deleteInArray, errorCatch, GET, updateInArray, useAuth } from 'fennec-ui';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';
import { getShkolaFromRoles } from '../../../common/Tool';
import User from '../../../common/User';
import AddBlacklistlShkoli from '../../forms/AddBlacklistlShkoli';
import PageLayout from '../../components/PageLayout';
import { useSchoolContext } from '../../../common/Context';

const { Option } = Select;


const useStyles = createUseStyles({
    block: {
        '& .buttons': {
            marginBottom: "10px"
        },
    },
    item: {
        padding: "5px 10px",
        display: "flex",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#f9f9f9"
        }
    },
})

export default function SchoolEducationBlacklist(props) {
    const [ctx, setSchool] = useSchoolContext();
    const classes = useStyles();
    const auth = useAuth();
    const dispatch = useDispatch();
   
    const sourceKey = "school";

    const filters = () => [
        {
            label: "Фамилия",
            name: "polzovatel.lastname",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Имя",
            name: "polzovatel.firstname",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Отчество",
            name: "polzovatel.patronymic",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Email",
            name: "polzovatel.email",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: <span>Телефон<span style={{
                fontStyle: "italic",
                fontSize: "11px",
                paddingLeft: "5px",
                color: "#818181"
            }}>(без +)</span></span>,
            name: "polzovatel.phone",
            // type: "string",
            sort: true,
            filter: true,
        },
        {
            label: "Дата рождения",
            name: "polzovatel.birthday",
            type: "date",
            filterType: "range",
            // func: ["min", "max"],
            sort: true,
            filter: true,
        },
    ];
    
    return (<PageLayout>
        <div>
            <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ fontSize: "24px" }}>Школа</div>
                {ctx && <CollectionServer
                    title={"Черный список школы " + ((ctx) ? "\"" + ctx.nazvanieShkoliTantsev + "\"" : "")}
                    name={"CherniiSpisokShkol"}
                    auth={auth}
                    size="small"
                    source={`/api/school/cherniispisok/list/${ctx?.ID}`}
                    filters={filters}
                    mode={"list"}
                    render={(item, idx, { setCollection, setCollectionItem, update }) => {
                        return (<div key={idx} style={{ width: "100%" }} className="students">
                            <div className={classes.item}>
                                <div style={{ flex: "auto" }}>
                                    <User item={item.polzovatel} />
                                </div>
                            </div>
                        </div>)
                    }}
                    collectionActions={() => [
                        {
                            action: (values, unlock, close, { collection, setCollection }) => {
                                GET(auth, `/api/add/school/${ctx?.ID}/cherniispisok/${values.polzovatel.ID}`,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data));
                                        close();
                                    }, (err) => errorCatch(err, unlock)
                                );
                            },
                            form: AddBlacklistlShkoli,
                            options: {
                                initialValues: {},
                            },
                            title: "Добавить пользователя",
                            modal: {
                                minWidth: "250px",
                                title: "Новый пользователь",
                            }
                        }
                    ]}
                    modelActions={(item) => [
                        {
                            title: <span style={{ color: "red" }}>Удалить</span>,
                            action: (values, unlock, close, { collection, setCollection }) => {
                                Modal.confirm({
                                    title: `Вы уверены что хотите удалить пользователя из черного списка?`,
                                    icon: <ExclamationCircleOutlined />,
                                    content: <User item={item.polzovatel} noborder={true} />,
                                    okText: "Да",
                                    okType: 'danger',
                                    cancelText: "Нет",
                                    onOk: () => {
                                        GET(auth, `/api/delete/school/cherniispisok/${item.ID}`,
                                            () => {
                                                setCollection(deleteInArray(collection, item));
                                            }, errorCatch);
                                    },
                                });
                            },
                        },
                    ]}
                />}
            </div>
        </div>
    </PageLayout>
    );
}
